class RegionalIncentives {
    static initialize() {
        this.waitForData(this.dataScriptId, this.redirectToUrl);
    }
    static waitForData(scriptId, callBack) {
        const interval = setInterval(() => {
            if (document.readyState === "complete") {
                clearInterval(interval);
                const jsonElement = document.getElementById(scriptId);
                if (jsonElement) {
                    try {
                        this.dataModel = JSON.parse(jsonElement.textContent);
                    }
                    catch (error) {
                        console.error("Error parsing JSON data:", error);
                    }
                    callBack();
                }
            }
        }, 500);
    }
    static redirectToUrl() {
        let t3websiteCookie = "";
        if (window.DealeronCookie) {
            t3websiteCookie =
                window.DealeronCookie.getItem("t3website") || "";
        }
        const guid = t3websiteCookie
            ? t3websiteCookie.match(/<cookieguid>([^<]*)<\/cookieguid>/)?.[1]
            : "";
        if (RegionalIncentives.dataModel) {
            const url = RegionalIncentives.dataModel.Host +
                RegionalIncentives.dataModel.QueryString +
                "&TertiarySource=" +
                guid;
            window.location.href = url;
        }
        else {
            console.error("dataModel is not available for redirection");
        }
    }
}
RegionalIncentives.dataScriptId = "regional-incentives-data";
RegionalIncentives.dataModel = {
    Host: "",
    QueryString: "",
};
export { RegionalIncentives };
RegionalIncentives.initialize();
